module.exports = __webpack_public_path__ + "static/media/minus.82a2047f.svg";